import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';

import { Button, Input } from 'antd';
import { ButtonQuestion } from '@/components/button/question';
import { sendEvent } from '../../utils/ga';

export const PageSignUp = () => {

  const onTrySignUp = (type: string) => {
    sendEvent('try_sign_up', { step: type })
  }

  const onSignUpClick = (type: string) => {
    sendEvent('sign_up', { method: type })
  }

  return (
    <>
      <Helmet>
        <title>회원 가입</title>
      </Helmet>
      <div className={styles.header}>
        <h2>회원 가입</h2>
      </div>
      <div className={styles.contents}>
        <div className={styles.rowInput}>
          <div className={styles.colLeft}>아이디</div>
          <div className={styles.colRight}>
            <Input onClick={(e) => onTrySignUp('id')} placeholder="아이디를 입력해주세요"/>
            <ButtonQuestion
              className={styles.question}
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'try_sign_up', {
  step: 'id'
})
`
                )
              }}
            />
          </div>
        </div>
        <div className={styles.rowInput}>
          <div className={styles.colLeft}>비밀번호</div>
          <div className={styles.colRight}>
            <Input onClick={(e) => onTrySignUp('password')} placeholder="비밀번호를 입력해주세요 (아무것이나 입력)"/>
            <ButtonQuestion
              className={styles.question}
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'try_sign_up', {
  step: 'password'
})
`
                )
              }}
            />
          </div>
        </div>
        <div className={styles.rowInput}>
          <div className={styles.colLeft}>비밀번호 확인</div>
          <div className={styles.colRight}>
            <Input onClick={(e) => onTrySignUp('password_check')} placeholder="비밀번호를 확인해주세요 (아무것이나 입력)"/>
            <ButtonQuestion
              className={styles.question}
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'try_sign_up', {
  step: 'password_check'
})
`
                )
              }}
            />
          </div>
        </div>
        <div className={styles.rowInput}>
          <div className={styles.colLeft}>휴대폰 번호 입력</div>
          <div className={styles.colRight}>
            <Input onClick={(e) => onTrySignUp('phone')} placeholder="휴대폰 번호를 입력해주세요 (아무것이나 입력)"/>
            <ButtonQuestion
              className={styles.question}
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'try_sign_up', {
  step: 'phone'
})
`
                )
              }}
            />
          </div>
        </div>
        <div className={styles.rowInput}>
          <div className={styles.colLeft}>휴대폰 인증하기</div>
          <div className={styles.colRight}>
            <Button onClick={(e) => onTrySignUp('phone_check')}>인증하기</Button>
            <ButtonQuestion
              className={styles.question}
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'try_sign_up', {
  step: 'phone_check'
})
`
                )
              }}
            />
          </div>
        </div>
        <div className={styles.rowInput}>
          <div className={styles.colLeft}>인증번호 입력</div>
          <div className={styles.colRight}>
            <Input onClick={(e) => onTrySignUp('phone_auth')} placeholder="인증 번호를 입력해주세요 (아무것이나 입력)"/>
            <ButtonQuestion
              className={styles.question}
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'try_sign_up', {
  step: 'phone_auth'
})
`
                )
              }}
            />
          </div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.rowActions}>
          <div className={styles.colBtnSignUp}>
            <Button onClick={(e) => onSignUpClick('google')}>구글로 회원가입</Button>
            <ButtonQuestion
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'sign_up', {
  method: 'google'
})
`
                )
              }}
            />
          </div>
          <div className={styles.colBtnSignUp}>
            <Button onClick={(e) => onSignUpClick('facebook')}>페이스북으로 가입</Button>
            <ButtonQuestion
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'sign_up', {
  method: 'facebook'
})
`
                )
              }}
            />
          </div>
          <div className={styles.colBtnSignUp}>
            <Button onClick={(e) => onSignUpClick('naver')}>네이버로 회원가입</Button>
            <ButtonQuestion
              sizePercentage="120%"
              content={() => {
                return (
`
gtag('event', 'sign_up', {
  method: 'naver'
})
`
                )
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}